import { gql } from '@apollo/client';

const schema = {
  get: {
    name: "user",
    serviceName: "auth",
    query: gql`
      query {
        user {
          id
          email
          gender
          lastname
          firstname
          birth_date
          skin_color
          national_code
        }
      }
    `,
  },
  update: {
    name: "updateUser",
    serviceName: "unitadmin",
    query: gql`
      mutation updateUser(
        $ids: [String]!
        $firstname: String
        $lastname: String
        $national_code: String
        $birth_date: String
        $skin_color: String # white , black , brown ???
        $tellphone: String
        $address: String
        $email: String
        $gender: Int
        $is_active: Int
        $status_id: String
        $medical_number: String
        $specialist: String
        $insurance_type: String
        $financial_situation: String
      ) {
        updateUser(
          ids: $ids
          firstname: $firstname
          lastname: $lastname
          national_code: $national_code
          birth_date: $birth_date
          skin_color: $skin_color
          tellphone: $tellphone
          address: $address
          email: $email
          gender: $gender
          is_active: $is_active
          status_id: $status_id
          medical_number: $medical_number
          specialist: $specialist
          insurance_type: $insurance_type
          financial_situation: $financial_situation
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
